import { apiBaseURL, authActionType, toastifyType } from '../../../constants';
import { setLoading } from '../loadingAction';
import { addTost } from '../toastAction';
import apiConfig from '../../../config/apiConfig';


export const register = (user, navigate) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await apiConfig.post(apiBaseURL.ADMIN_REGISTER, user);
    if (response?.data?.success) {
      dispatch({ type: authActionType.REGISTER, payload: response.data.data });
      dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response.data.message }));
      navigate('/signin');
    }
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
    console.error('error', error);
  }
};